import PropTypes from 'prop-types';
import React from 'react';
import s from './WorkTracker.module.scss';
import { sortDirection } from './lib/sorting';

// Column headings over the list. Each is a sort: click to sort by that column,
// click again to flip it. Widths come from the same classes TaskCard uses.
export const COLUMNS = [
  { sort: 'title', label: 'Task', className: s.colTitle },
  { sort: 'added', label: 'Created', className: s.colCreated },
  { sort: 'priority', label: 'Priority', className: s.colPriority },
  { sort: 'due', label: 'Due', className: s.colDue },
  { sort: 'status', label: 'Status', className: s.colStatus },
];

export default function ListHeader({ sort, reverse, onSort }) {
  return (
    <div className={s.listHead} role="group" aria-label="Sort by column">
      <span className={s.headGrip} aria-hidden="true" />
      {COLUMNS.map((col) => {
        const active = col.sort === sort;
        const dir = active ? sortDirection(sort, reverse) : null;
        return (
          <button
            type="button"
            key={col.sort}
            className={`${s.headBtn} ${col.className}`}
            data-active={active ? 'true' : undefined}
            data-dir={dir || undefined}
            aria-pressed={active}
            aria-label={`Sort by ${col.label.toLowerCase()}`}
            title={active ? 'Click to flip the order' : `Sort by ${col.label.toLowerCase()}`}
            onClick={() => onSort(col.sort)}
          >
            {col.label}
            {active && <span className={s.headArrow} aria-hidden="true">{dir === 'desc' ? '▼' : '▲'}</span>}
          </button>
        );
      })}
    </div>
  );
}

ListHeader.propTypes = {
  sort: PropTypes.string.isRequired,
  reverse: PropTypes.bool,
  onSort: PropTypes.func.isRequired,
};
ListHeader.defaultProps = { reverse: false };
